import axios from 'axios'
import debounce from 'debounce-promise'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { OptionTypeBase } from 'react-select'
import { API_HOST } from '../../consts'
import InputAsync from './InputAsync'

interface RoomInputProps extends OptionTypeBase {
  params?: any
}

const RoomInput = ({ params, ...props }: RoomInputProps) => {
  const { t } = useTranslation()

  // eslint-disable-next-line
  const fetchRooms = useCallback(
    debounce(async (search) => {
      const response = await axios.get(`${API_HOST}/v1/rooms`, {
        params: {
          search,
          ...params
        }
      })
      return response.data.results
    }, 500),
    [params]
  )

  return (
    <InputAsync
      key={JSON.stringify(params)}
      defaultOptions
      loadOptions={fetchRooms}
      label={t('Room')}
      name="room"
      getOptionValue={(d) => d.id}
      getOptionLabel={(d) => d.name}
      {...props}
    />
  )
}

export default RoomInput
